import { InsightsGlobalFilters } from './insights.model';

type ValuesOf<T> = T[keyof T];

export const AUDITABLE_TYPES = {
  CREDENTIAL: 'Credential',
  GROUP: 'Group',
  DESIGN: 'Design',
  GROUP_SKILL_ASSOCIATION: 'GroupSkillAssociation',
  SKILL_FRAMEWORK_ORGANIZATION: 'SkillFrameworkOrganization',
  SKILL_FRAMEWORK_CORPORATION: 'SkillFrameworkCorporation',
  SKILL_FRAMEWORK_CONFIGURATION_ORGANIZATION: 'SkillFrameworkConfigurationOrganization',
  SKILL_FRAMEWORK_CONFIGURATION_CORPORATION: 'SkillFrameworkConfigurationCorporation',
} as const;

export type AuditableType = ValuesOf<typeof AUDITABLE_TYPES>;

export class AuditLogsBadRequestError extends Error {}

export interface AuditLog {
  id: number;
  auditable_id: number;
  auditable_type: AuditableType;
  username: string;
  user_id: number;
  user_type: string;
  action: string;
  audited_changes: {
    updated_at: string[];
    name: string[];
  };
  created_at: string;
  source: string;
}

export interface AuditLogsFilters extends InsightsGlobalFilters {
  page_size: number;
  page: number;
  auditable_type: AuditableType;
  auditable_id: string;
  issuer_login_id: string;
}
